export default "__VITE_ASSET__B51_c5vK__"